import RoomsReservationsPage from "./RoomsReservationsPage";

export default RoomsReservationsPage;
